import React from "react";
import { Helmet } from "react-helmet-async";

const SeoHelmet = ({ title, description, keywords }) => {
  return (
    <Helmet>
      <title>{title || "Premium uniform manufacturer in Chennai"}</title>
      <meta
        name="description"
        content={description || "Workdayz is  trusted uniform manufacturer in Chennai, delivering premium corporate, school, and healthcare uniforms with quality, comfort, and style."}
      />
      <meta name="keywords" content={keywords || "uniform manufacturer"} />
    </Helmet>
  );
};

export default SeoHelmet;
